
import { defineComponent } from 'vue'
import { AlButton } from '~/components/ui'
import { getExternalCompareMobileHref } from '~/utils/external-links.utils'

export default defineComponent({
  name: 'MoreExclusive',
  components: {
    AlButton,
  },
  computed: {
    externalCompareMobileHref () {
      return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath)
    },
  },
})
